import axios from 'axios'
import qs from 'qs'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'

// axios.defaults.headers["Content-type"] = "application/json"

// 创建axios实例
const service = axios.create({
	baseURL: process.env.BASE_API, // api的base_url
	timeout: 150000 // 请求超时时间
})

// console.log(process.env.BASE_API)
// request拦截器
service.interceptors.request.use(config => {
	if (store.getters.token) {
		config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
	}
	return config
}, error => {
	// Do something with request error
	console.log(error) // for debug
	Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
	response => {
		const res = response.data
		if (res.size) {
			const blob = new Blob([res])
			const timestamp = new Date().getTime()
			if ('download' in document.createElement('a')) { // 非IE下载
				const eLink = document.createElement('a')
				if (response.headers['content-disposition']) {
					eLink.download = decodeURIComponent(response.headers['content-disposition'].split('=')[1])
				} else {
					eLink.download = `${timestamp}.xls`
				}
				eLink.style.display = 'none'
				eLink.href = URL.createObjectURL(blob)
				document.body.appendChild(eLink)
				eLink.click()
				URL.revokeObjectURL(eLink.href) // 释放URL 对象
				document.body.removeChild(eLink)
			} else { // IE10+下载
				navigator.msSaveBlob(blob, `${timestamp}.xls`)
			}
			return ""
		}

		if (res.code !== 200) {
			Message({
				message: res.message,
				type: 'error',
				duration: 3 * 1000
			})

			// 401:未登录;
			if (res.code === 401) {
				MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
					confirmButtonText: '重新登录',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					store.dispatch('FedLogOut').then(() => {
						location.reload()// 为了重新实例化vue-router对象 避免bug
					})
				})
			}
			return Promise.reject(res)
		} else {
			return response.data
		}
	},
	error => {
		// console.log(error.response.data.message)// for debug
		Message({
			message: error.response.data.message,
			type: 'error',
			duration: 2000
		})
		return Promise.reject(error)
	}
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js